module.exports = __webpack_public_path__ + "static/media/konstruktor.c683dd8a.svg";